import { render, staticRenderFns } from "./correctionNotebookSix.vue?vue&type=template&id=ac0e91de&scoped=true"
import script from "./correctionNotebookSix.vue?vue&type=script&lang=js"
export * from "./correctionNotebookSix.vue?vue&type=script&lang=js"
import style0 from "./correctionNotebookSix.vue?vue&type=style&index=0&id=ac0e91de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0e91de",
  null
  
)

export default component.exports